import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "tools/routerCompat";
import MCard from "components/Shared/MCard.tsx";
import { DATA_TYPE_HYPERLINK } from "typeConstants/dataTypes";
import { getPublicPropertyRecord } from "actions/homeowner/caseforms";
import { openGoogleMapsLink } from "components/Shared/Functions";

class PublicPropertyRecord extends React.Component {  
  componentDidUpdate(prevProps) {
    const { controlNumber, getPublicPropertyRecord } = this.props;
    if (!prevProps.controlNumber && controlNumber) {
      getPublicPropertyRecord(controlNumber);
    }
  }

  UNSAFE_componentWillMount() {
    const {
      controlNumber,
      getPublicPropertyRecord
    } = this.props;
    if (controlNumber) {
      getPublicPropertyRecord(controlNumber);
    }

    this.createDiscrepancyField = this.createDiscrepancyField.bind(this);
  }

  createDiscrepancyField() {
    const { publicPropertyRecord: { buildingArea, discrepancyStatus, discrepancyExplanation, sketchSqFt } } = this.props;

    if (buildingArea && buildingArea > 0) {
      switch (discrepancyStatus) {
        case "ACCEPTED":
          return {
            label: "Sketch Discrepancy",
            value: "No"
          };
        case "EXPLAINED":
          return {
            label: "Sketch Discrepancy",
            value: { label: "Yes", onClick: () => { } },
            dataType: DATA_TYPE_HYPERLINK,
            tooltip: {
              title: "Details", fields: [{
                label: "", value: `The Mueller Field Representative is aware that the Public Record information for this home indicates a TLA of ${buildingArea} SQFT.
After review of the home and the attached diagram the Mueller Field Representative believes the correct TLA is ${sketchSqFt} SQFT.      
The Mueller Field Representative identified the most likely reason(s) for the discrepancy as: ${discrepancyExplanation === "Unknown" ? "An error in the public record" : discrepancyExplanation}.`
              }]
            }
          };
        default:
          return {
            label: "Sketch Discrepancy",
            value: "Unconfirmed"
          };
      }
    }

    return {
      label: "Sketch Discrepancy"
    };
  }

  getAddressValue() {
    const { publicPropertyRecord: { siteAddress, siteCity, siteState, siteZip } } = this.props;
    if (!siteAddress) {
      return null;
    } else {
      return { label: siteAddress, onClick: () => openGoogleMapsLink(`${siteAddress} ${siteCity}, ${siteState} ${siteZip}`)};
    }
  }

  render() {
    const { publicPropertyRecord: { siteAddress, siteCity, siteState, siteZip, yearBuilt, buildingArea, numberOfStories, numberOfUnits, bedrooms, baths, pdfPath, discrepancyEnabled } } = this.props;

    let firstcolumn = [
      {
        label: "Address",
        value: this.getAddressValue(),
        dataType: siteAddress ? DATA_TYPE_HYPERLINK : null
      },
      {
        label: "City",
        value: siteCity
      },
      {
        label: "State",
        value: siteState
      },
      {
        label: "Zip",
        value: siteZip
      },
      {
        label: "Sketch",
        key: "pdfLink",
        value: { label: "Computer Generated", onClick: pdfPath },
        dataType: DATA_TYPE_HYPERLINK
      }
    ];

    if (discrepancyEnabled) {
      firstcolumn.push(this.createDiscrepancyField());
    }

    let secondcolumn = [
      {
        label: "Tax Record Year Built",
        value: yearBuilt
      },
      {
        label: "Total Living Area (sq ft)",
        value: buildingArea
      },
      {
        label: "# of Stories",
        value: numberOfStories
      },
      {
        label: "# of Units",
        value: numberOfUnits
      },
      {
        label: "# of Bedrooms",
        value: bedrooms
      },
      {
        label: "# of Baths",
        value: baths
      },
    ];

    return (
      <MCard title="Public Property Record" isFetching={!Object.keys(this.props.publicPropertyRecord).length}
        fields={[firstcolumn, secondcolumn]} />
    );
  }
}
PublicPropertyRecord.propTypes = {
  controlNumber: PropTypes.number.isRequired,
  publicPropertyRecord: PropTypes.object,
  getPublicPropertyRecord: PropTypes.func.isRequired
};
const mapStateToProps = (state) => {
  return {
    publicPropertyRecord: state.caseForms.publicPropertyRecord
  };
};
const mapDispatchToProps = (dispatch) => ({
  getPublicPropertyRecord(controlNumber) {
    dispatch(getPublicPropertyRecord(controlNumber));
  }
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PublicPropertyRecord));